import styled from "styled-components";

import heroBg from "../../../assets/images/pattern-white.jpg";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Hero = styled.div`
  position: relative;
  width: 100%;
  color: #fff;
  background-color: #e1000f;
`;

export const HeroImageContainer = styled.div`
  width: 100%;
  height: 264px;
  background-image: url(${heroBg});
  background-repeat: no-repeat;
  background-position-x: left;
  background-position-y: top;
  mix-blend-mode: multiply;

  @media (width < 4000px) {
    background-size: 2260px auto;
  }

  @media (width >= 4000px) {
    background-size: 100% auto;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  padding: 24px;
`;

export const HeroTitle = styled.h1`
  font-size: 65px;
  font-weight: 500;
  line-height: 68px;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
`;

export const Desc = styled.p`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const AccessSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (width < 1024px) {
    gap: 31px;
    padding: 32px 24px;
  }

  @media (width >= 1024px) {
    gap: 67px;
    padding: 72px 32px;
  }
`;

export const AccessSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 735px;
  text-align: center;
`;

export const AccessSectionGrid = styled.div`
  display: flex;
  width: 100%;

  @media (width < 1024px) {
    flex-direction: column;
    gap: 37px;
  }

  @media (width >= 1024px) {
    gap: 48px;
    max-width: 852px;
  }

  @media (width >= 1440px) {
    max-width: 1292px;
  }
`;

export const Card = styled.a`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;

  &.--video {
    align-items: center;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CardTitle = styled.h5`
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
`;

export const VideosSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (width < 1024px) {
    gap: 32px;
    padding: 32px 24px;
  }

  @media (width >= 1024px) {
    gap: 48px;
    padding: 72px 32px;
  }
`;

export const VideosGrid = styled.div`
  width: 100%;

  @media (width < 1024px) {
    display: flex;
    flex-direction: column;
    row-gap: 48px;
  }

  @media (width >= 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    column-gap: 26px;
    row-gap: 80px;
    max-width: 852px;
  }

  @media (width >= 1440px) {
    grid-template-columns: 1fr 1fr 1fr;
    max-width: 1292px;
  }
`;
